import { purchaseApi } from './purchase.api';

export const purchaseActions = {
  async getPurchases({ commit }, payload) {
    try {
      commit('GET_PURCHASES_LOADING');
      const response = await purchaseApi.getPurchases(payload);
      commit('GET_PURCHASES_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_PURCHASES_ERROR', error.response);
    }
  },
  async getPurchase({ commit }, id) {
    try {
      commit('GET_PURCHASE_LOADING');
      const response = await purchaseApi.getPurchase(id);
      commit('GET_PURCHASE_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_PURCHASE_ERROR', error.response);
    }
  },
};
